import { render, staticRenderFns } from "./CopyViaContentPublishing.vue?vue&type=template&id=00b607c6&scoped=true"
import script from "./CopyViaContentPublishing.vue?vue&type=script&lang=js"
export * from "./CopyViaContentPublishing.vue?vue&type=script&lang=js"
import style0 from "./CopyViaContentPublishing.vue?vue&type=style&index=0&id=00b607c6&prod&scoped=true&lang=css"
import style1 from "./CopyViaContentPublishing.vue?vue&type=style&index=1&id=00b607c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b607c6",
  null
  
)

export default component.exports